import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken, ok } from '../../utils/response';
import { errorResponse, okResponse, notFoundResponse } from '../../utils/response';
import { Token, UserCode, EmployeeId, EmployeeCode, Company } from '../../utils/users';
import { IsEnglish } from '../../utils/language';
import { encryption } from '../../utils/encryption';

export function getAllLists() {
    let url = 'availability/getAllLists?' + objectToQueryString({ userCode: encryption(UserCode()), employeeId: encryption(EmployeeId()), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponse(JSON.parse(response.result));
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getTemplateDetail(templateId) {
    let url = 'availability/getTemplateDetail?' + objectToQueryString({
        userCode: encryption(UserCode()),
        employeeId: encryption(EmployeeId()),
        templateId: encryption(templateId),
        languageInt: IsEnglish() ? 1 : 2,
        token: Token()
    });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponse({ result: JSON.parse(response.result) });
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function savePeriod(scheduleAvailabilityId, startDate, endDate, comment) {
    return fetch('availability/SavePeriod', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCodeCrypt: encryption(UserCode()),
            employeeIdCrypt: encryption(EmployeeId()),
            scheduleAvailabilityIdCrypt: encryption(scheduleAvailabilityId),
            startDate: startDate,
            endDate: endDate,
            comment: comment,
            languageInt: IsEnglish() ? 1 : 2,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponse({ result: JSON.parse(response.result) });
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function saveAvailability(scheduleAvailabilityId, startTime, endTime, oldStartTime, oldEndTime, shift, day1, day2, day3, day4, day5, day6, day7) {
    return fetch('availability/SaveAvailability', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCodeCrypt: encryption(UserCode()),
            employeeIdCrypt: encryption(EmployeeId()),
            scheduleAvailabilityIdCrypt: encryption(scheduleAvailabilityId),
            startTime: startTime,
            endTime: endTime,
            oldStartTime: oldStartTime,
            oldEndTime: oldEndTime,
            shift: shift,
            day1: day1,
            day2: day2,
            day3: day3,
            day4: day4,
            day5: day5,
            day6: day6,
            day7: day7,
            languageInt: IsEnglish() ? 1 : 2,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponse({ result: JSON.parse(response.result) });
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function deleteAvailability(day1Id, day2Id, day3Id, day4Id, day5Id, day6Id, day7Id) {
    return fetch('availability/deleteAvailability', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCodeCrypt: encryption(UserCode()),
            day1IdCrypt: encryption(day1Id),
            day2IdCrypt: encryption(day2Id),
            day3IdCrypt: encryption(day3Id),
            day4IdCrypt: encryption(day4Id),
            day5IdCrypt: encryption(day5Id),
            day6IdCrypt: encryption(day6Id),
            day7IdCrypt: encryption(day7Id),
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return ok();
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function createAvailabilityFromTemplate(scheduleAvailabilityId, templateAvailableId) {
    return fetch('availability/createAvailabilityFromTemplate', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCodeCrypt: encryption(UserCode()),
            scheduleAvailabilityIdCrypt: encryption(scheduleAvailabilityId),
            templateAvailableIdCrypt: encryption(templateAvailableId),
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return ok();
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getExceptionList() {
    let url = 'availability/getExceptionList?' + objectToQueryString({ userCode: encryption(UserCode()), employeeId: encryption(EmployeeId()), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponse({ result: JSON.parse(response.result) });
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}


export function saveException(exceptionId, startDate, endDate, startTime, endTime, comment, isPartial) {
    return fetch('availability/SaveException', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCodeCrypt: encryption(UserCode()),
            employeeCodeCrypt: encryption(EmployeeCode()),
            companyCrypt: encryption(Company()),
            exceptionIdCrypt: encryption(exceptionId),
            startDate: startDate,
            endDate: endDate,
            startTime: startTime,
            endTime: endTime,
            comment: comment,
            isPartial: isPartial,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return ok();
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}


export function deleteException(exceptionId) {
    return fetch('availability/DeleteException', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCodeCrypt: encryption(UserCode()),
            exceptionIdCrypt: encryption(exceptionId),
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return ok();
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}